<script>
import { DateElementMixin } from "%/dynamic-components/render-engine/components/production/elements/text-element/date-element-mixin";
import {
  UserProfilePageElementMixin,
} from "~/dynamic-components/standard-pages/user-profile-page/user-profile-page-element-mixin";
import TextElement
  from "%/dynamic-components/render-engine/components/production/elements/text-element/TextElement.vue";
import BrandedTextStyleOptions from "%/dynamic-components/render-engine/bundles/branded-text-style-options";
import DynamicElementWithContext from "%/dynamic-components/render-engine/mixins/production/dynamic-element-with-context-mixin";

export default {
  name: "DynamicAppDateElement",
  extends: TextElement,
  mixins: [UserProfilePageElementMixin, DateElementMixin, DynamicElementWithContext],
  elementPanelSettings: {
    displayName: "DynamicAppDateElement",
    displayIcon: "document",
    elementGroup: "currentUser",
    elementType: "element",
  },
  hidden: true,
  optionBundles: [
    new BrandedTextStyleOptions({}, {
      "text-option": true,
    }),
  ],
  computed: {
    isEditable() {
      return false;
    },
    value() {
      return this.formattedDate(this.valueFromContext);
    },
  },
};
</script>
